import { get, post, AHPLUS_API_URL, patch } from "api/ky";
import { BankFields } from "types/bankFields";

export const BASE_RESOURCE_URL = `${AHPLUS_API_URL}/api/v2/air_bundle/journeys`;

export type AirLuggagePaymentPax = {
  id: number;
  numberOfLuggages: number;
  payoutEligibleItineraryId: number;
  pirReference: File;
  boardingPassOrBookingReference: File;
  passportOrId: File;
  baggageTag: File;
};

export type AirLuggageRequest = {
  countryId: string;
  bankFields: BankFields;
  airLuggageJourneys: AirLuggagePaymentPax[];
};

export type AirLuggageUpdateRequest = {
  countryId: string;
  bankFields: BankFields;
};

export const fetchAirLuggageForJourneys = async (journeyId: number) => {
  return await get(`${BASE_RESOURCE_URL}/${journeyId}/air_luggage_journeys`);
};

export const triggerAirLuggageForJourneys = async (journeyId: number, payload: AirLuggageRequest, token = "") => {
  return await post(`${BASE_RESOURCE_URL}/${journeyId}/air_luggage_journeys/payout?token=${token}`, payload);
};

export const updateAirLuggageForJourneys = async (journeyId: number, payload: AirLuggageUpdateRequest, token = "") => {
  return await patch(`${BASE_RESOURCE_URL}/${journeyId}/air_luggage_journeys/payout_update?token=${token}`, payload);
};
